import React from 'react';
import { ArrowDownCircle } from 'lucide-react';
export function CtaSection() {
  const scrollToOrder = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('order-bump')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 px-6 bg-[#13132b] border-y border-white/5" data-id="element-46">
      <div className="flex flex-col items-center text-center space-y-4" data-id="element-47">
        <div className="flex items-center gap-3 text-lg" data-id="element-48">
          <span className="text-gray-400 line-through" data-id="element-49">De $39.990</span>
          <span className="font-black text-yellow-400" data-id="element-50">→ HOY $19.990 ARS</span>
        </div>

        <button onClick={scrollToOrder} className="w-full max-w-sm bg-gradient-to-r from-yellow-400 to-yellow-600 hover:from-yellow-300 hover:to-yellow-500 text-slate-900 font-black text-sm py-4 rounded-xl shadow-[0_0_20px_rgba(250,204,21,0.2)] transform transition active:scale-95 flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-51">
          VER TODO LO QUE INCLUYE Y ELEGIR MI KIT
          <ArrowDownCircle className="w-5 h-5" data-id="element-52" />
        </button>
      </div>
    </section>;
}